import { stagger, timeline } from "motion";
import "@/styles/components/page-header.css";

const pageHeader = document.querySelector(".page-header");

export default {
  init: async () => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    if (!pageHeader || !pageHeader.classList.contains("as-media-right")) {
      return;
    }

    pageHeader.classList.remove("motion-safe:invisible");

    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    const circleBg = pageHeader.querySelector(".circle-bg");
    const circleTransform = {
      [isDesktop ? "x" : "y"]: [isDesktop ? "-110%" : "100%", 0],
    };

    if (!isDesktop) {
      pageHeader.classList.add("overflow-clip");
    }

    await timeline([
      [
        circleBg.querySelectorAll("div"),
        circleTransform,
        {
          duration: 0.8,
          delay: stagger(0.2),
        },
      ],
      [
        pageHeader.querySelector(".media-slider"),
        {
          opacity: [0, 1],
        },
        {
          easing: "ease-in",
          duration: 0.8,
          at: "-0.7",
        },
      ],
      [
        pageHeader.querySelectorAll(".page-header-content > *"),
        {
          opacity: [0, 1],
          transform: ["translate3d(0,20%,0)", "translate3d(0,0,0)"],
        },
        {
          duration: 0.8,
          at: "<",
        },
      ],
      pageHeader.querySelector(".color-bar")
        ? [
            pageHeader.querySelector(".color-bar"),
            {
              opacity: [0, 1],
            },
            {
              duration: 0.4,
              at: "<",
            },
          ]
        : [],
      [
        pageHeader.querySelector(".block-bg"),
        {
          opacity: [0, 1],
        },
        {
          duration: 0.4,
        },
      ],
    ]).finished;

    if (!isDesktop) {
      pageHeader.classList.remove("overflow-clip");
    }
  },
};
